// extracted by mini-css-extract-plugin
export default {"cls1":"LbXi1GjQymtYyJtHia5L","cls2":"dWFP6eMQONiu1x7EfpQu LbXi1GjQymtYyJtHia5L"};